<template>
  <div class="animated fadeIn">
    <div class="card">
      <div class="main-card-body">
        <div class="body-header d-flex justify-content-between align-items-center">
          <div>
            <el-breadcrumb separator-class="el-icon-arrow-right">
              <el-breadcrumb-item class="bold">Cấu hình chấm công</el-breadcrumb-item>
              <el-breadcrumb-item :to="{ name: 'Admin-Timekeeping-TimekeepingConfig-AgentConnection' }">Kết nối Agent</el-breadcrumb-item>
              <el-breadcrumb-item>Giám sát & Điều khiển Agent</el-breadcrumb-item>
            </el-breadcrumb>
          </div>
          <div>
            <el-button size="small" class="btn-back" @click="$router.push({ name: 'Admin-Timekeeping-TimekeepingConfig-AgentConnection' })">
              <i class="fas fa-arrow-left mr-1"></i> Quay lại
            </el-button>
          </div>
        </div>

        <div class="main-body mt-4">
          <!-- BẢNG THỐNG KÊ TỔNG QUAN -->
          <div class="agent-summary-cards mb-4">
            <b-row>
              <b-col md="3" sm="6" class="mb-2">
                <div class="summary-card card-blue">
                  <div class="summary-icon"><i class="fas fa-server"></i></div>
                  <div class="summary-info">
                    <div class="summary-label">Agent Hoạt Động</div>
                    <div class="summary-value">
                      <span class="text-success font-weight-bold">{{ onlineAgentCount }}</span> / {{ agentList.length }} Online
                    </div>
                  </div>
                </div>
              </b-col>
              <b-col md="3" sm="6" class="mb-2">
                <div class="summary-card card-green">
                  <div class="summary-icon"><i class="fas fa-fingerprint"></i></div>
                  <div class="summary-info">
                    <div class="summary-label">Máy Chấm Công LAN</div>
                    <div class="summary-value">
                      <span class="text-success font-weight-bold">{{ onlineDevicesCount }}</span> / {{ totalDevicesCount }} Máy Online
                    </div>
                  </div>
                </div>
              </b-col>
              <b-col md="3" sm="6" class="mb-2">
                <div class="summary-card card-purple">
                  <div class="summary-icon"><i class="fas fa-network-wired"></i></div>
                  <div class="summary-info">
                    <div class="summary-label">Kết Nối Máy Chủ (BE)</div>
                    <div class="summary-value">
                      <span class="badge-dot dot-green"></span> Sẵn sàng (Port 5000)
                    </div>
                  </div>
                </div>
              </b-col>
              <b-col md="3" sm="6" class="mb-2">
                <div class="summary-card card-orange">
                  <div class="summary-icon"><i class="fas fa-exchange-alt"></i></div>
                  <div class="summary-info">
                    <div class="summary-label">Luồng Dữ Liệu I/O</div>
                    <div class="summary-value">
                      <span class="text-success font-weight-bold">Realtime</span> (In & Out OK)
                    </div>
                  </div>
                </div>
              </b-col>
            </b-row>
          </div>

          <!-- THANH CÔNG CỤ TÁC VỤ TOÀN HỆ THỐNG -->
          <div class="d-flex justify-content-between align-items-center mb-3">
            <div>
              <h5 class="mb-0 font-weight-bold text-dark">
                <i class="fas fa-satellite-dish text-primary mr-2"></i>Trung Tâm Điều Khiển & Giám Sát Agent
              </h5>
              <small class="text-muted">Theo dõi sức khỏe các Agent, số lượng máy chấm công kết nối, và điều khiển từ xa không cần động vào máy khách</small>
            </div>
            <div>
              <el-button
                size="small"
                type="danger"
                plain
                @click="fn_purgeAllAgents"
                :loading="isPurgingAll"
                class="mr-2"
              >
                <i class="fas fa-broom mr-1"></i> Dọn dẹp tất cả máy chấm công
              </el-button>
              <el-button
                size="small"
                class="btn-default"
                @click="fn_initData"
                :loading="isRefreshing"
              >
                <i class="fas fa-sync-alt mr-1"></i> Làm mới trạng thái
              </el-button>
            </div>
          </div>

          <!-- BẢNG DANH SÁCH GIÁM SÁT AGENT -->
          <div class="list-agent-monitor">
            <el-table :data="agentList" border style="width: 100%" v-loading="isRefreshing">
              <el-table-column label="STT" width="50" align="center">
                <template slot-scope="scope">
                  <span class="font-weight-bold">{{ scope.$index + 1 }}</span>
                </template>
              </el-table-column>

              <el-table-column prop="name" label="Tên Agent" min-width="170">
                <template slot-scope="scope">
                  <div class="font-weight-bold text-primary">{{ scope.row.name }}</div>
                  <small class="text-muted">ID: {{ scope.row.id }}</small>
                </template>
              </el-table-column>

              <!-- TRẠNG THÁI AGENT -->
              <el-table-column label="Trạng thái Agent" min-width="150" align="center">
                <template slot-scope="scope">
                  <div v-if="scope.row.isOnline">
                    <el-tag type="success" size="small" effect="dark">
                      <i class="fas fa-circle font-xs mr-1"></i> Online
                    </el-tag>
                    <div class="font-xs text-muted mt-1">Vừa hoạt động</div>
                  </div>
                  <div v-else>
                    <el-tag type="info" size="small" effect="plain">
                      <i class="fas fa-circle font-xs mr-1 text-secondary"></i> Chờ kết nối
                    </el-tag>
                    <div class="font-xs text-muted mt-1">{{ scope.row.lastActiveText || "Chưa có log" }}</div>
                  </div>
                </template>
              </el-table-column>

              <!-- MÁY CHẤM CÔNG (LAN) -->
              <el-table-column label="Máy chấm công (LAN)" min-width="170" align="center">
                <template slot-scope="scope">
                  <el-popover
                    trigger="hover"
                    placement="top"
                    width="280"
                    v-if="scope.row.devices && scope.row.devices.length > 0"
                  >
                    <div>
                      <div class="font-weight-bold mb-2">Thiết bị kết nối qua Agent:</div>
                      <ul class="pl-3 mb-0">
                        <li v-for="dev in scope.row.devices" :key="dev.id || dev.ip">
                          <span class="badge badge-success mr-1" v-if="dev.is_active || dev.isOpen">Online</span>
                          <span class="badge badge-secondary mr-1" v-else>Offline</span>
                          <strong>{{ dev.ip }}</strong> <span class="text-muted font-xs">({{ dev.name || 'Hikvision' }})</span>
                        </li>
                      </ul>
                    </div>
                    <div slot="reference" style="cursor: pointer;">
                      <el-tag :type="scope.row.deviceOnlineCount > 0 ? 'success' : 'warning'" size="small">
                        <i class="fas fa-fingerprint mr-1"></i>
                        {{ scope.row.deviceOnlineCount || 0 }} / {{ scope.row.deviceCount || 0 }} Máy
                      </el-tag>
                    </div>
                  </el-popover>
                  <div v-else>
                    <span class="text-muted font-xs">Chưa có thiết bị</span>
                  </div>
                </template>
              </el-table-column>

              <!-- TRẠNG THÁI I/O -->
              <el-table-column label="Trạng thái I/O" min-width="180" align="center">
                <template slot-scope="scope">
                  <div class="font-xs text-left" style="line-height: 1.6;">
                    <div><i class="fas fa-arrow-circle-down text-success mr-1"></i> In: Log chấm công <strong class="text-success">OK</strong></div>
                    <div><i class="fas fa-arrow-circle-up text-primary mr-1"></i> Out: Lệnh điều khiển <strong class="text-primary">OK</strong></div>
                  </div>
                </template>
              </el-table-column>

              <!-- API KEY -->
              <el-table-column prop="api_key" label="API Key" min-width="220">
                <template slot-scope="scope">
                  <el-tooltip content="Bấm để copy API Key" placement="top">
                    <span class="code-box" @click="fn_copyApiKey(scope.row.api_key)">
                      {{ scope.row.api_key }}
                    </span>
                  </el-tooltip>
                </template>
              </el-table-column>

              <!-- ĐIỀU KHIỂN TỪ XA -->
              <el-table-column label="Điều khiển từ xa" width="180" align="center" fixed="right">
                <template slot-scope="scope">
                  <div class="action-buttons-group">
                    <!-- KHỞI ĐỘNG LẠI AGENT -->
                    <el-tooltip content="Khởi động lại Agent từ xa" placement="top">
                      <el-button
                        type="warning"
                        size="mini"
                        circle
                        class="action-btn"
                        @click="fn_restartAgent(scope.row)"
                      >
                        <i class="fas fa-redo-alt"></i>
                      </el-button>
                    </el-tooltip>

                    <!-- DỌN DẸP BỘ NHỚ MÁY CHẤM CÔNG -->
                    <el-tooltip content="Dọn dẹp bộ nhớ máy chấm công (xóa nhân viên đã nghỉ DA_NGHI)" placement="top">
                      <el-button
                        type="danger"
                        size="mini"
                        circle
                        class="action-btn"
                        @click="fn_purgeAgentCapacity(scope.row)"
                      >
                        <i class="fas fa-broom"></i>
                      </el-button>
                    </el-tooltip>

                    <!-- NHẬT KÝ LỖI & SỨC KHỎE -->
                    <el-tooltip content="Xem nhật ký lỗi / Lịch sử lệnh" placement="top">
                      <el-button
                        type="info"
                        size="mini"
                        circle
                        class="action-btn"
                        @click="fn_viewAgentErrors(scope.row)"
                      >
                        <i class="fas fa-bug"></i>
                      </el-button>
                    </el-tooltip>

                    <!-- QUẢN LÝ THIẾT BỊ CHI TIẾT -->
                    <el-tooltip content="Quản lý chi tiết thiết bị" placement="top">
                      <el-button
                        type="primary"
                        size="mini"
                        circle
                        class="action-btn"
                        @click="$router.push({ name: 'Admin-Timekeeping-TimekeepingConfig-AgentConnectionManagement', params: { id: scope.row.id } })"
                      >
                        <i class="fas fa-cog"></i>
                      </el-button>
                    </el-tooltip>
                  </div>
                </template>
              </el-table-column>
            </el-table>
          </div>
        </div>
      </div>
    </div>

    <!-- DIALOG NHẬT KÝ LỖI & GIÁM SÁT AGENT -->
    <el-dialog
      :title="'Nhật ký lệnh & Lỗi: ' + selectedAgentName"
      :visible.sync="dialogAgentErrors"
      width="75%"
    >
      <div class="p-3">
        <div class="d-flex justify-content-between align-items-center mb-3">
          <div>
            <strong>Agent ID:</strong> <code>{{ selectedAgentId }}</code>
          </div>
          <div>
            <el-button size="small" type="primary" plain @click="fn_testHealth(selectedAgentId)">
              <i class="fas fa-heartbeat mr-1"></i> Ping kiểm tra sức khỏe
            </el-button>
          </div>
        </div>

        <div v-if="selectedAgentCommands.length === 0" class="text-center py-4 text-muted">
          <i class="fas fa-check-circle text-success font-xl mb-2"></i>
          <div>Chưa có lỗi nào được ghi nhận từ Agent này. Hệ thống hoạt động bình thường.</div>
        </div>

        <el-table :data="selectedAgentCommands" border style="width: 100%" v-else max-height="400">
          <el-table-column prop="command" label="Mã lệnh" min-width="150">
            <template slot-scope="scope">
              <code>{{ scope.row.command }}</code>
            </template>
          </el-table-column>
          <el-table-column label="Lệnh tiếng Việt" min-width="190">
            <template slot-scope="scope">
              <span class="font-weight-bold text-dark">{{ fn_getCommandTitleVi(scope.row.command) }}</span>
            </template>
          </el-table-column>
          <el-table-column prop="created_at" label="Thời gian" width="160" align="center"></el-table-column>
          <el-table-column label="Trạng thái" width="130" align="center">
            <template slot-scope="scope">
              <el-tag type="success" size="small" v-if="scope.row.is_success === true">Thành công</el-tag>
              <el-tag type="danger" size="small" v-else-if="scope.row.is_success === false">Lỗi</el-tag>
              <el-tag type="warning" size="small" v-else>Đang chờ xử lý</el-tag>
            </template>
          </el-table-column>
          <el-table-column label="Chi tiết phản hồi / Báo lỗi" min-width="250">
            <template slot-scope="scope">
              <span class="text-warning" v-if="scope.row.is_success === null || scope.row.is_success === undefined">
                <i class="fas fa-clock mr-1"></i> Đang chờ Agent tiếp nhận &amp; xử lý...
              </span>
              <span class="text-danger" v-else-if="scope.row.is_success === false">
                <i class="fas fa-exclamation-triangle mr-1"></i> {{ fn_getCommandResponseMessage(scope.row) }}
              </span>
              <span class="text-success" v-else>
                <i class="fas fa-check-circle mr-1"></i> {{ fn_getCommandResponseMessage(scope.row) }}
              </span>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogAgentErrors = false" class="btn-back">Đóng</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import MethodService from "../../../../../service/MethodService";
import AgentApi from "../../../../../moduleApi/AgentApi";
import DeviceApi from "../../../../../moduleApi/DeviceApi";
import CommandQueueApi from "../../../../../moduleApi/CommandQueueApi";
import EmployeeApi from "../../../../../moduleApi/EmployeeApi";

export default {
  name: "AgentMonitor",
  data() {
    return {
      agentList: [],
      allDevices: [],
      commandHistory: [],
      dialogAgentErrors: false,
      selectedAgentName: "",
      selectedAgentId: "",
      selectedAgentCommands: [],
      isPurgingAll: false,
      isRefreshing: false
    };
  },

  computed: {
    onlineAgentCount() {
      return this.agentList.filter(a => a.isOnline).length;
    },
    totalDevicesCount() {
      return this.allDevices.length;
    },
    onlineDevicesCount() {
      return this.allDevices.filter(d => d.is_active || d.isOpen).length;
    }
  },

  methods: {
    async fn_initData() {
      this.isRefreshing = true;
      try {
        const [agentApiRes, deviceApiRes, commandApiRes] = await Promise.all([
          AgentApi.list(),
          DeviceApi.list({ limit: 1000 }).catch(() => ({ result: [] })),
          CommandQueueApi.list({ limit: 200, sort: "-created_at" }).catch(() => ({ result: [] }))
        ]);

        this.allDevices = (deviceApiRes && deviceApiRes.result) ? deviceApiRes.result : [];
        this.commandHistory = (commandApiRes && commandApiRes.result) ? commandApiRes.result : [];

        if (agentApiRes && agentApiRes.result) {
          this.agentList = this.fn_enrichAgentData(agentApiRes.result);
        }
      } catch (error) {
        console.error("fn_initData error:", error);
      } finally {
        this.isRefreshing = false;
      }
    },

    fn_enrichAgentData(agents) {
      const now = new Date();
      return agents.map(agent => {
        const item = { ...agent };
        const agentDevices = this.allDevices.filter(d => d.agent_id === item.id);
        item.devices = agentDevices;
        item.deviceCount = agentDevices.length;
        item.deviceOnlineCount = agentDevices.filter(d => d.is_active === true || d.isOpen === true).length;

        // A queued command and an enabled device do not prove the Agent is online.
        const responseTimes = this.commandHistory
          .filter(c => c.agent_id === item.id && c.result != null &&
            String(c.result).trim() !== "" && (c.result_time || c.updated_at))
          .map(c => new Date(c.result_time || c.updated_at).getTime())
          .filter(time => Number.isFinite(time) && time <= now.getTime());
        const lastResponseTime = responseTimes.length ? Math.max(...responseTimes) : null;

        if (lastResponseTime !== null) {
          const elapsed = now.getTime() - lastResponseTime;
          const diffMinutes = Math.floor(elapsed / (1000 * 60));
          item.isOnline = !item.disabled && elapsed <= 15 * 60 * 1000;
          item.lastActiveText = diffMinutes <= 1 ? "Vừa xong" : `${diffMinutes} phút trước`;
        } else {
          item.isOnline = false;
          item.lastActiveText = "Chưa có phản hồi";
        }

        return item;
      });
    },

    fn_copyApiKey(key) {
      if (!key) return;
      navigator.clipboard.writeText(key);
      window.toastr.info("Đã sao chép API Key vào clipboard!");
    },

    fn_restartAgent(row) {
      this.$confirm(
        `Bạn có chắc chắn muốn gửi lệnh KHỞI ĐỘNG LẠI Agent [${row.name}] từ xa không?\n(Tiến trình Agent trên máy khách sẽ tự động khởi động lại trong 2-3 giây)`,
        "Khởi động lại Agent từ xa",
        {
          confirmButtonText: "Khởi động lại",
          cancelButtonText: "Hủy",
          type: "warning"
        }
      ).then(async () => {
        try {
          await CommandQueueApi.create({
            agent_id: row.id,
            command: "RestartAgent",
            params: []
          });
          window.toastr.success(`Đã phát lệnh khởi động lại tới Agent [${row.name}]!`);
          setTimeout(() => { this.fn_initData(); }, 2000);
        } catch (e) {
          window.toastr.error("Lỗi khi gửi lệnh: " + (e.message || e));
        }
      }).catch(() => {});
    },

    async fn_getResignedEmployeeCodes() {
      const codes = new Set();
      const limit = 1000;
      let offset = 0;
      while (true) {
        const empRes = await EmployeeApi.list({ limit, offset, sort: "employee_no" });
        if (!empRes || !Array.isArray(empRes.result)) {
          throw new Error("Không tải được danh sách nhân viên để dọn dẹp.");
        }
        const list = empRes.result;
        const resignedList = list.filter(e => {
          return e.disabled === true ||
                 e.status === "DA_NGHI" ||
                 e.status === "NGHI_VIEC" ||
                 e.status === "THOI_VIEC" ||
                 (e.job_info && e.job_info.status === "DA_NGHI");
        });
        resignedList.forEach(e => {
          if (e.employee_no && e.employee_no.trim()) codes.add(e.employee_no.trim());
        });
        offset += list.length;
        const total = empRes.meta && empRes.meta.total;
        if (typeof total === "number") {
          if (offset >= total) break;
          if (list.length === 0) throw new Error("Danh sách nhân viên chưa tải đầy đủ.");
        } else if (list.length < limit) {
          break;
        }
      }
      return Array.from(codes);
    },

    fn_purgeAgentCapacity(row) {
      this.$confirm(
        `Gửi lệnh dọn dẹp bộ nhớ máy chấm công cho Agent [${row.name}]?\n\nHệ thống sẽ tự động đối soát và XÓA toàn bộ hồ sơ nhân sự đã thôi việc/nghỉ làm (DA_NGHI) khỏi các máy chấm công Hikvision của Agent này.`,
        "Dọn dẹp bộ nhớ máy chấm công",
        {
          confirmButtonText: "Dọn dẹp ngay",
          cancelButtonText: "Hủy",
          type: "warning"
        }
      ).then(async () => {
        try {
          const resignedCodes = await this.fn_getResignedEmployeeCodes();
          if (resignedCodes.length === 0) {
            window.toastr.info("Không có nhân viên nghỉ việc hoặc bị khóa cần dọn dẹp.");
            return;
          }
          await CommandQueueApi.create({
            agent_id: row.id,
            command: "PurgeDeviceCapacity",
            params: [JSON.stringify(resignedCodes)]
          });
          window.toastr.success(`Đã phát lệnh dọn dẹp bộ nhớ tới Agent [${row.name}] (${resignedCodes.length} nhân sự đã nghỉ)!`);
          setTimeout(() => { this.fn_initData(); }, 2000);
        } catch (e) {
          window.toastr.error("Lỗi khi gửi lệnh: " + (e.message || e));
        }
      }).catch(() => {});
    },

    fn_purgeAllAgents() {
      this.$confirm(
        "Bạn có chắc muốn phát lệnh dọn dẹp bộ nhớ cho TẤT CẢ các Agent trong công ty?\n(Toàn bộ nhân sự đã nghỉ việc DA_NGHI sẽ được làm sạch trên tất cả các máy chấm công)",
        "Dọn dẹp tất cả máy chấm công",
        {
          confirmButtonText: "Thực hiện toàn bộ",
          cancelButtonText: "Hủy",
          type: "warning"
        }
      ).then(async () => {
        this.isPurgingAll = true;
        try {
          const resignedCodes = await this.fn_getResignedEmployeeCodes();
          if (resignedCodes.length === 0) {
            window.toastr.info("Không có nhân viên nghỉ việc hoặc bị khóa cần dọn dẹp.");
            return;
          }
          for (const agent of this.agentList) {
            await CommandQueueApi.create({
              agent_id: agent.id,
              command: "PurgeDeviceCapacity",
              params: [JSON.stringify(resignedCodes)]
            });
          }
          window.toastr.success(`Đã phát lệnh dọn dẹp tới tất cả ${this.agentList.length} Agent (${resignedCodes.length} nhân sự đã nghỉ)!`);
        } catch (e) {
          window.toastr.error("Lỗi khi phát lệnh: " + (e.message || e));
        } finally {
          this.isPurgingAll = false;
          setTimeout(() => { this.fn_initData(); }, 2000);
        }
      }).catch(() => {});
    },

    fn_viewAgentErrors(row) {
      this.selectedAgentName = row.name;
      this.selectedAgentId = row.id;
      const cmds = this.commandHistory.filter(c => c.agent_id === row.id);
      this.selectedAgentCommands = cmds.map(c => ({
        ...c,
        created_at: c.created_at ? MethodService.formatDate(c.created_at, "datetime") : "---"
      }));
      this.dialogAgentErrors = true;
    },

    async fn_testHealth(agentId) {
      try {
        await CommandQueueApi.create({
          agent_id: agentId,
          command: "GetAgentHealth",
          params: []
        });
        window.toastr.info("Đã gửi gói tin ping kiểm tra sức khỏe tới Agent!");
        setTimeout(() => {
          this.fn_initData();
          this.fn_viewAgentErrors({ id: this.selectedAgentId, name: this.selectedAgentName });
        }, 2000);
      } catch (e) {
        window.toastr.error("Lỗi: " + (e.message || e));
      }
    },

    fn_getCommandTitleVi(command) {
      const commandMap = {
        PurgeDeviceCapacity: "Dọn dẹp bộ nhớ máy",
        UpdateFaceToDevices: "Cập nhật khuôn mặt lên máy",
        UpdateEmployeeToDevices: "Cập nhật thông tin lên máy",
        SaveEmployeeToDevices: "Lưu / Đăng ký nhân viên vào máy",
        AddEmployeeToDevices: "Thêm nhân viên vào máy",
        RemoveEmployeeToDevices: "Xóa nhân viên khỏi máy",
        GetAddedEmployees: "Lấy danh sách nhân viên trên máy",
        GetListDevices: "Lấy danh sách thiết bị",
        ActiveDevice: "Kích hoạt thiết bị",
        AddPassword: "Cài mật khẩu thiết bị",
        SetDeviceTime: "Đồng bộ thời gian máy",
        GetDeviceTime: "Kiểm tra giờ trên máy",
        SetDeviceStaticIp: "Cài đặt IP tĩnh",
        PostDataTime: "Cài giờ lấy dữ liệu",
        GetDataTime: "Xem giờ lấy dữ liệu",
        AddEmployee: "Thêm nhân viên",
        UpdateEmployee: "Cập nhật nhân viên",
        RemoveEmployee: "Xóa nhân viên",
        UpdateFace: "Cập nhật khuôn mặt",
        RestartAgent: "Khởi động lại Agent",
        GetAgentHealth: "Kiểm tra sức khỏe Agent"
      };
      return commandMap[command] || command || "---";
    },

    fn_translateErrorMessage(msg) {
      if (!msg || typeof msg !== "string") return "Lỗi xử lý lệnh";
      if (msg.includes("AnonymousType") || msg.includes("does not contain a definition for 'IsSuccess'")) {
        return "Lỗi xung đột kiểu dữ liệu (bản ghi từ Agent phiên bản cũ)";
      }
      if (/invalid datetime/i.test(msg)) {
        return msg.replace(/Params\[(\d+)\]\s*(in\s*)?invalid datetime/gi, "Sai định dạng ngày giờ ở tham số thứ $1");
      }
      if (/Device\s+([^\s]+)\s+not found/i.test(msg)) {
        return msg.replace(/Device\s+([^\s]+)\s+not found/gi, "Không tìm thấy máy chấm công $1");
      }
      if (/Device password is empty/i.test(msg)) {
        return msg.replace(/Device password is empty for\s+([^\s]+)/gi, "Chưa cấu hình mật khẩu cho thiết bị $1");
      }
      if (/Device configuration not found/i.test(msg)) {
        return msg.replace(/Device configuration not found for\s+([^\s]+)/gi, "Không tìm thấy cấu hình thiết bị $1");
      }
      if (/Employee not found/i.test(msg)) {
        return "Không tìm thấy nhân viên trên máy chấm công";
      }
      if (/Params\[(\d+)\]\s*is missing/i.test(msg)) {
        return msg.replace(/Params\[(\d+)\]\s*is missing/gi, "Thiếu dữ liệu tham số [$1]");
      }
      if (/connect|timeout|refused/i.test(msg)) {
        return "Lỗi kết nối tới máy chấm công (quá thời gian hoặc từ chối kết nối)";
      }
      return msg;
    },

    fn_getCommandResponseMessage(row) {
      if (row.is_success === null || row.is_success === undefined) {
        return "Đang chờ Agent tiếp nhận & xử lý...";
      }
      if (row.is_success === false) {
        let rawErr = row.error_message || "";
        if (!rawErr && row.result) {
          try {
            const parsed = JSON.parse(row.result);
            if (typeof parsed === "object" && parsed !== null) {
              if (parsed.Result && Array.isArray(parsed.Result.listResult) && parsed.Result.listResult.length > 0) {
                return parsed.Result.listResult.map(item => this.fn_translateErrorMessage(item)).join(", ");
              }
              if (parsed.listResult && Array.isArray(parsed.listResult) && parsed.listResult.length > 0) {
                return parsed.listResult.map(item => this.fn_translateErrorMessage(item)).join(", ");
              }
              if (parsed.Result && parsed.Result.message) rawErr = parsed.Result.message;
              else if (parsed.message) rawErr = parsed.message;
              else if (typeof parsed.Result === "string") rawErr = parsed.Result;
            }
          } catch (e) {
            rawErr = row.result;
          }
        }
        if (!rawErr) rawErr = row.result || row.message || "Lỗi xử lý lệnh";
        return this.fn_translateErrorMessage(rawErr);
      }
      // is_success === true
      if (row.result) {
        try {
          const parsed = JSON.parse(row.result);
          if (typeof parsed === "object" && parsed !== null) {
            if (parsed.Result && parsed.Result.message) return parsed.Result.message;
            if (parsed.message) return parsed.message;
            if (typeof parsed.Result === "string") return parsed.Result;
          }
        } catch (e) {
          if (typeof row.result === "string") return row.result;
        }
      }
      return row.message || row.response || "Hoàn tất thành công";
    }
  },

  created() {
    this.fn_initData();
  }
};
</script>

<style scoped>
.agent-summary-cards .summary-card {
  display: flex;
  align-items: center;
  padding: 16px;
  border-radius: 8px;
  background: #fff;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.05);
  border-left: 4px solid #ccc;
  transition: all 0.2s ease;
}
.agent-summary-cards .summary-card:hover {
  transform: translateY(-2px);
  box-shadow: 0 4px 14px rgba(0, 0, 0, 0.1);
}
.card-blue { border-left-color: #20a8d8 !important; }
.card-blue .summary-icon { color: #20a8d8; background: #e8f4f9; }

.card-green { border-left-color: #4dbd74 !important; }
.card-green .summary-icon { color: #4dbd74; background: #edf7f0; }

.card-purple { border-left-color: #6f42c1 !important; }
.card-purple .summary-icon { color: #6f42c1; background: #f2edf9; }

.card-orange { border-left-color: #f86c6b !important; }
.card-orange .summary-icon { color: #f86c6b; background: #fef0f0; }

.summary-icon {
  width: 46px;
  height: 46px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 20px;
  margin-right: 14px;
}
.summary-label {
  font-size: 12px;
  color: #888;
  font-weight: 500;
  text-transform: uppercase;
  letter-spacing: 0.5px;
}
.summary-value {
  font-size: 15px;
  font-weight: 600;
  color: #333;
  margin-top: 2px;
}
.badge-dot {
  display: inline-block;
  width: 8px;
  height: 8px;
  border-radius: 50%;
  margin-right: 4px;
}
.dot-green { background-color: #4dbd74; }

.code-box {
  background: #f4f6f9;
  padding: 4px 8px;
  border-radius: 4px;
  font-family: monospace;
  font-size: 12px;
  color: #e83e8c;
  cursor: pointer;
  border: 1px dashed #d1d5db;
}
.code-box:hover {
  background: #e9ecef;
}

.action-buttons-group {
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 6px;
}
.action-btn {
  width: 28px !important;
  height: 28px !important;
  padding: 0 !important;
  font-size: 11px !important;
  display: inline-flex !important;
  align-items: center !important;
  justify-content: center !important;
}

.font-xs {
  font-size: 11px;
}
.font-xl {
  font-size: 32px;
}

::v-deep .el-dialog__body {
  padding: 10px 20px !important;
}
::v-deep .el-dialog__header {
  background-color: #f8f9fa !important;
  border-bottom: 1px solid #ebedf2 !important;
  padding: 15px 20px !important;
}
</style>
